module.exports = __webpack_public_path__ + "static/cl-tinto-prod-bb1eefb7b1d2ac3437ad18206aa110ea.jpg";